import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import 'antd/dist/antd.css';
import './react/shared/styles/ar_main.less';
import './App.less';
import Recipient from './components/Recipient';
import Unsubscribe from './components/Unsubscribe';
import Error from './components/Error';
import SmsPage from './pages/SmsPage';
import { Row, Col } from 'antd';
import { BrowserRouter as Router,Route,Switch } from "react-router-dom";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Provider store={store}>
        <Router>
          <Row>
            <Col>
              <div className="App">
                <Switch>
                  <Route path={"/email/:language/:recipientUuid/unsubscribe"} component={Unsubscribe} />
                  <Route path={"/email/:type/:language/:recipientUuid"} component={Recipient} />
                  <Route path={"/email/:language/:recipientUuid"} component={Recipient}/>
                  <Route path={"/email/:language"} component={Error}/>
                  <Route path={"/sms/:language"} component={SmsPage}/>
                  <Route component={Error} />
                </Switch>
              </div>
            </Col>
          </Row>
        </Router>
      </Provider>
    );
  }
}

export default App;
